

export class Site {
    Id: number;
    Name: string;
    StudyIds: number[] = [];
    ActivationTimestamps: number[] = [];

    constructor(id: number, name: string) { this.Id = id; this.Name = name; }
}